export const DEFAULT_LANGUAGE = 'fr-FR';
export const SECOND_LANGUAGE = 'en-US';

export const LANGUAGES = [DEFAULT_LANGUAGE, SECOND_LANGUAGE];
